import React from 'react'
import PropTypes from 'prop-types'
import {
  DollarOutlined,
  SmileOutlined,
  MedicineBoxOutlined,
  LikeOutlined
} from '@ant-design/icons'
import Provider from 'model/provider/provider'

import {
  RowWrap,
  ItemLabel,
  LowCostIcon,
  SatisfactionIcon,
  QualityLocationIcon,
  QualityProviderIcon
} from './styled'

const ProviderBadges = ({ provider }) => {
  const {
    high_patient_satisfaction,
    high_quality_practice_location,
    high_quality_provider,
    low_cost_provider
  } = provider

  const hasNoBadges =
    !high_patient_satisfaction &&
    !high_quality_practice_location &&
    !high_quality_provider &&
    !low_cost_provider

  return (
    <RowWrap data-test="providerBadges">
      {low_cost_provider && (
        <ItemLabel>
          <LowCostIcon>
            <DollarOutlined />
          </LowCostIcon>{' '}
          Low Cost
        </ItemLabel>
      )}
      {high_patient_satisfaction && (
        <ItemLabel>
          <SatisfactionIcon>
            <SmileOutlined />
          </SatisfactionIcon>
          High Patient Satisfaction
        </ItemLabel>
      )}
      {high_quality_practice_location && (
        <ItemLabel>
          <QualityLocationIcon>
            <MedicineBoxOutlined />
          </QualityLocationIcon>{' '}
          High Quality Location
        </ItemLabel>
      )}
      {high_quality_provider && (
        <ItemLabel>
          <QualityProviderIcon>
            <LikeOutlined />
          </QualityProviderIcon>{' '}
          High Quality Provider
        </ItemLabel>
      )}
      {hasNoBadges && 'N/A'}
    </RowWrap>
  )
}

ProviderBadges.propTypes = {
  provider: PropTypes.instanceOf(Provider).isRequired
}

export default ProviderBadges
